import styled from "styled-components"

export const CtaBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  backdrop-filter: blur(5px);
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.12) 100%
  );
  border-top: 1px solid rgba(255, 255, 255, 0.54);
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`

export const IconButton = styled.button`
  min-width: 48px;
  min-height: 48px;
  width: 48px;
  height: 48px;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5.25px);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s ease, opacity 0.2s ease;
  -webkit-tap-highlight-color: transparent;

  &:active {
    transform: scale(0.95);
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const CaptureButton = styled.button`
  width: 69px;
  height: 69px;
  min-width: 69px;
  min-height: 69px;
  border-radius: 50%;
  background: #ffffff;
  border: 7px solid #d9d9d9;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;
  position: relative;

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: #ffffff;
  }
`

export const SettingsIconSvg = styled.svg`
  width: 24px;
  height: 24px;
`
